import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { GlobalService } from "@frontend/app/serivces/global.service";
import { HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { AsteriskMessageDirective } from "@frontend/app/directives/asterikmessage.directive";
import { Cls_StudentEnquiry } from "@frontend/app/models/master";
import { MasterService } from "@frontend/app/serivces/master.service";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-inquiry-form",
  imports: [CommonModule, SharedModule, FormsModule, AsteriskMessageDirective],
  templateUrl: "./inquiry-form.component.html",
  styleUrl: "./inquiry-form.component.scss",
})
export class InquiryFormComponent implements OnInit, OnDestroy {
  private globalService = inject(GlobalService);
  private masterService = inject(MasterService);
  private toastr = inject(ToastrService);
  private router = inject(Router);
  private http = inject(HttpClient);

  ngOnInit() {
    this.globalService.setIsShowFalse();
  }
  //#region varibles
  readonly SVG_ICONS = SVG_ICONS;
  genders = ["Male", "Female", "Other"];
  ErrorMsg: string[] = [];
  inquryDetails = new Cls_StudentEnquiry();
  //#endregion

  calculateAge() {
    if (this.inquryDetails.DateOfBirth) {
      const today = new Date();
      const birthDate = new Date(this.inquryDetails.DateOfBirth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      this.inquryDetails.Age = age;
    } else {
      this.inquryDetails.Age = undefined;
    }
  }

  getAddressByPincode(pincode: string | undefined) {
    if (!pincode || pincode.length !== 6) return;

    this.http.get(`https://api.postalpincode.in/pincode/${pincode}`).subscribe({
      next: (response: any) => {
        if (response[0]?.Status === "Success") {
          const postOffice = response[0].PostOffice[0];
          this.inquryDetails.City = postOffice.District;
          this.inquryDetails.State = postOffice.State;
        } else {
          this.inquryDetails.City = "";
          this.inquryDetails.State = "";
        }
      },
      error: (err: any) => {
        console.error("Error fetching address:", err);
        this.inquryDetails.City = "";
        this.inquryDetails.State = "";
      },
    });
  }

  validateForm(): boolean {
    let valid = true;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|net|org|in)$/;
    const mobilePattern = /^[0-9]{10}$/;
    const pincodePattern = /^[0-9]{6}$/;
    // const messages: string[] = [];

    const requiredFields: {
      key: keyof Cls_StudentEnquiry;
      label: string;
      type?: "string" | "date" | "number" | "file";
    }[] = [
      { key: "FirstName", label: "First Name", type: "string" },
      // { key: "MiddleName", label: "Middle Name", type: "string" },
      { key: "LastName", label: "Last Name", type: "string" },
      { key: "DateOfBirth", label: "Date of Birth", type: "date" },
      { key: "Gender", label: "Gender", type: "string" },
      { key: "MobileNo", label: "Contact Number", type: "string" },
      { key: "City", label: "City", type: "string" },
      { key: "State", label: "State", type: "string" },
      { key: "CenterName", label: "Center Name", type: "string" },
    ];
    for (const field of requiredFields) {
      const value = this.inquryDetails[field.key] as any;
      if (value == null || (typeof value === "string" && !value.trim())) {
        this.ErrorMsg.push(`${field.label}`);
        continue;
      }
      switch (field.key) {
        case "Email":
          if (!emailPattern.test(value)) {
            this.ErrorMsg.push(`Please enter a valid email address.`);
          }
          break;

        case "MobileNo":
          if (!mobilePattern.test(value)) {
            this.ErrorMsg.push(`${field.label} must be a 10-digit number.`);
          }
          break;

        case "Pincode":
          if (!pincodePattern.test(value)) {
            this.ErrorMsg.push(`${field.label} must be a 6-digit number.`);
          }
          break;
      }
    }
    const isValid = this.ErrorMsg.length === 0;
    if (!isValid) {
      this.toastr.error("Please fill all required fields.", "Info");
    }
    return isValid;
  }

  onSubmit() {
    this.ErrorMsg = [];
    if (!this.validateForm()) return;
    const tempModal = new Cls_StudentEnquiry();
    tempModal.FirstName = this.inquryDetails.FirstName;
    tempModal.MiddleName = this.inquryDetails.MiddleName;
    tempModal.LastName = this.inquryDetails.LastName;
    tempModal.DateOfBirth = this.inquryDetails.DateOfBirth;
    tempModal.Gender = this.inquryDetails.Gender;
    tempModal.Email = this.inquryDetails.Email;
    tempModal.MobileNo = this.inquryDetails.MobileNo;
    tempModal.CenterName = this.inquryDetails.CenterName;
    tempModal.Pincode = this.inquryDetails.Pincode;
    tempModal.City = this.inquryDetails.City;
    tempModal.State = this.inquryDetails.State;
    tempModal.Height = this.inquryDetails.Height;
    tempModal.Weight = this.inquryDetails.Weight;
    tempModal.Age = this.inquryDetails.Age;
    tempModal.ExperienceLevel = this.inquryDetails.ExperienceLevel;
    tempModal.PreferredBatchTime = this.inquryDetails.PreferredBatchTime;
    tempModal.PreferredDays = this.inquryDetails.PreferredDays;
    tempModal.MedicalCondition = this.inquryDetails.MedicalCondition;
    tempModal.EnquirySource = this.inquryDetails.EnquirySource;
    tempModal.ReferenceName = this.inquryDetails.ReferenceName;
    tempModal.CounsellorName = this.inquryDetails.CounsellorName;

    this.masterService.addInquiry(tempModal).subscribe((response: any) => {
      this.toastr.success("Inquiry added successfully");
      this.router.navigate(["inquiries"]);
    });
  }

  onClose() {
    this.router.navigate(["inquiries"]);
  }
  ngOnDestroy() {
    this.globalService.setIsShowTrue();
  }
}
